module.exports = __webpack_public_path__ + "img/LP---Image-Placeholder---6.6599250b.png";